/*
------------------------------------------------
Delishop Framework
Problem Delishop
Version: 1.0
Compatible: Shrine Pro 1.5.4
------------------------------------------------
*/

(function () {

    function initProblem(section) {

        // Sección estática.
        // No requiere lógica JavaScript en esta versión.

    }

    document.addEventListener("DOMContentLoaded", function () {

        document.querySelectorAll(".dh-problem").forEach(initProblem);

    });

    document.addEventListener("shopify:section:load", function (event) {

        const section = event.target.querySelector(".dh-problem");

        if (section) {
            initProblem(section);
        }

    });

})();